// src/hooks/useAutoTranslate.js
import esTranslations from '../locales/es.json';
import enTranslations from '../locales/en.json';

const translations = {
  es: esTranslations,
  en: enTranslations,
};

const useAutoTranslate = () => {
  // Obtener el lenguaje default del localStorage
  const getDefaultLanguage = () => {
    try {
      const systemSettings = localStorage.getItem('systemSettings');
      
      if (systemSettings) {
        const settings = JSON.parse(systemSettings);
        
        // El language está dentro de APPLICATION
        if (settings.APPLICATION && 
            settings.APPLICATION.language && 
            settings.APPLICATION.language.default) {
          return settings.APPLICATION.language.default;
        }
      }
      
      // Fallback final: español
      return 'es';
      
    } catch (error) {
      return 'es';
    }
  };

  const currentLanguage = getDefaultLanguage();
  
  const autoT = (text, options = {}) => {
    if (!text || typeof text !== 'string') return text;
    
    // Limpiar el texto
    const cleanText = text.trim().replace(/\s+/g, ' ');
    
    // Generar clave
    const key = cleanText
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/(^_+|_+$)/g, '');
    
    
    // Obtener traducción
    const currentTranslations = translations[currentLanguage] || {};
    let result = currentTranslations[key] || cleanText;
    
    
    // Reemplazar variables
    if (options && typeof options === 'object') {
      Object.keys(options).forEach(optKey => {
        const regex = new RegExp(`{{\\s*${optKey}\\s*}}`, 'g');
        result = result.replace(regex, options[optKey]);
      });
    } else {
      result = cleanText;
    }
    
    return result;
  };
  
  const i18n = {
    language: currentLanguage
  };
  
  return { autoT, i18n };
};

export default useAutoTranslate;